import * as React from 'react';
import {
   Accordion,
   AccordionDetails,
   AccordionSummary,
   Typography,
   Box,
   Container
} from '@mui/material';
import { theme } from 'theme';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


interface FaqData {
   id: string,
   question: string,
   answer: string
}

const faqData: FaqData[] = [
   {
      id: 'panel1',
      question: 'What Are the Operating Hours of Laundromats in Hamilton?',
      answer:
         'We are open every day to fit laundry into your schedule. Your search for the perfect laundromat ends here. If you have any specific questions, we ll be happy to answer them.'
   },
   {
      id: 'panel2',
      question: 'Do Laundromats in Hamilton Offer Additional Services Like Wash-And-Fold or Dry Cleaning?',
      answer:
         'Our Hamilton laundromats offer complete self-service laundry options, including fast, premium, self-serve wash and self-serve dry services. Please contact us for detailed information about our services.'
   },
   {
      id: 'panel3',
      question: 'What Payment Methods Are Accepted?',
      answer:
         'E-SmartWash is a modern Hamilton laundromat that accepts multiple payment methods. You can make contactless payments through our app or choose card payments for convenience.'
   }
];

export const FAQs = () => {
   const [expanded, setExpanded] = React.useState<string | false>(false);

   const handleChange =
      (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
         setExpanded(isExpanded ? panel : false);
      };

   return (
      <Box component="section" py={4} mb={6}>
         <Container>
            <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center" sx={{ marginBottom: "3.5rem" }}>
               Frequently Asked {' '}
               <Box component="span" sx={{ color: theme.palette.secondary.main }}>
                  Questions
               </Box>
            </Typography>

            {faqData.map(({ id, question, answer }) => (
               <Accordion key={id} expanded={expanded === id} sx={{ borderBottom: "1px solid #000" }} onChange={handleChange(id)}  >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`${id}-header`}>
                     <Typography variant="h6" fontWeight={expanded === id ? "600" : "400"} color={expanded === id ? theme.palette.secondary.main : '#000'}  >{question} </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                     <Typography>{answer}</Typography>
                  </AccordionDetails>
               </Accordion>
            ))}
         </Container>
      </Box>
   );
};
